import type { ProjectId } from "providers/ProjectContext";
import { useProjectContext } from "providers/ProjectContext";

export function useProjectId(): ProjectId {
  return useProjectContext().projectId;
}
